import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Java",
    "Python",
    "C",
    "C#",
    "Ruby",
    "Go",
    "Haskell",
    "Node.js",
    "TypeScript",
    "GCP Firebase",
    "Git",
    "PostgreSQL",
    "Spring Boot",
    "Flask/FastAPI",
    ".NET",
    "Angular",
    "React",
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Docker",
    "Kubernetes",
    "GCP",
    "AWS (EC2, S3, Lambda,EKS, RDS)",
    "Azure DevOps",
    "Azure",
    "Linux",
    "Snowflake",
    "Pandas",
    "Selenium",
    "Puppeteer",
    "Beautiful Soup",
    "Pandas",
    "Jenkins",
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Qdrant",
    "Hugging Face",
    "LlamaIndex",
    "Streamlit",
    "Scikit-Learn",
    "Streamlit",
    "TensorFlow",
    "PyTorch",
    "Matplotlib",
    "Seaborn",
    "MCP",
    "Gemini",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Software Engineering</h3>
                    <p>I engineer high-performance, resilient backend systems and microservices capable of handling large-scale data ingestion and processing. My experience ranges from developing cloud-connected telemetry systems for autonomous guided vehicles to optimizing forensic data libraries that eliminate processing bottlenecks on corrupted evidence.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>I design mock-driven test infrastructure, build robust CI/CD pipelines, and manage containerized deployments to ensure zero-downtime and regression-free production environments. I specialize in optimizing data pipelines, safeguarding against production crashes, and orchestrating cloud environments.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>I build production-grade, context-aware GenAI systems and automated code review pipelines. By combining LLM inference with scalable data structures, context-retrieval mechanisms, and prompt injection mitigations, I create intelligent systems designed to analyze massive datasets safely and efficiently.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;